// Helpers API du pilotage (Mission 3, Lot 3). Auth par Bearer (clé ose_auth, cohérent avec l'admin existant).
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function getToken() {
  return sessionStorage.getItem('ose_auth') || localStorage.getItem('ose_auth');
}

function authHeaders(json = true) {
  const h = { Authorization: `Bearer ${getToken()}` };
  if (json) h['Content-Type'] = 'application/json';
  return h;
}

async function handle(res) {
  if (res.status === 401 || res.status === 403) {
    const e = new Error('Accès refusé'); e.code = res.status; throw e;
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const e = new Error(data.detail || 'Erreur serveur'); e.code = res.status; e.detail = data.detail; throw e;
  }
  return data;
}

export const api = {
  base: BACKEND,
  get: (path) => fetch(`${BACKEND}${path}`, { headers: authHeaders(false) }).then(handle),
  post: (path, body) => fetch(`${BACKEND}${path}`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(body || {}) }).then(handle),
  // Endpoints dossier
  aujourdhui: () => api.get('/api/dossiers/aujourdhui'),
  liste: () => api.get('/api/dossiers/liste'),
  etat: (id) => api.get(`/api/dossiers/${id}/etat`),
  transition: (id, event, extra = {}) => api.post(`/api/dossiers/${id}/transition`, { event, ...extra }),
  devis: (id) => fetch(`${BACKEND}/api/devis/${id}`).then(handle),
  historique: (id) => fetch(`${BACKEND}/api/devis/${id}/historique`).then(handle),
  relance: (id) => api.post(`/api/devis/${id}/envoyer`, {}),
  products: () => fetch(`${BACKEND}/api/products`).then(handle),
  patchDevis: (id, patch) => fetch(`${BACKEND}/api/dossiers/${id}/devis`, { method: 'PATCH', headers: authHeaders(), body: JSON.stringify(patch) }).then(handle),
  paiementManuel: (id, type) => api.post(`/api/devis/${id}/paiement-manuel`, { type, methode: 'cb' }),
  facturesDossier: (quoteId) => api.get(`/api/factures/dossier/${quoteId}`),
};

// ─── Factures / Impayés / Export comptable (Lot 4) ─────────────────────────────
function qs(params) {
  const p = Object.entries(params || {}).filter(([, v]) => v !== undefined && v !== null && v !== '');
  return p.length ? '?' + p.map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&') : '';
}
async function handleBlob(res) {
  if (res.status === 401 || res.status === 403) { const e = new Error('Accès refusé'); e.code = res.status; throw e; }
  if (!res.ok) { const e = new Error('Erreur serveur'); e.code = res.status; throw e; }
  return res.blob();
}
export const factures = {
  list: (params) => api.get(`/api/factures${qs(params)}`),
  impayes: () => api.get('/api/factures/impayes'),
  dossier: (quoteId) => api.get(`/api/factures/dossier/${quoteId}`),
  marquerReglee: (id, mode) => api.post(`/api/factures/${id}/marquer-reglee`, { mode }),
  renvoyer: (id) => api.post(`/api/factures/${id}/renvoyer`, {}),
  avoir: (id, body) => api.post(`/api/factures/${id}/avoir`, body),
  rembourser: (id, body) => api.post(`/api/factures/${id}/rembourser`, body),
  marquerRembourse: (id) => api.post(`/api/factures/${id}/marquer-rembourse`, {}),
  relancerImpayes: (body) => api.post('/api/factures/relancer-impayes', body || {}),
  anomalies: () => api.get('/api/factures/anomalies'),
  reconcilier: () => api.post('/api/factures/reconcilier', {}),
  openPdf: async (id) => {
    const blob = await fetch(`${BACKEND}/api/factures/${id}/pdf`, { headers: authHeaders(false) }).then(handleBlob);
    window.open(URL.createObjectURL(blob), '_blank');
  },
  exportFile: async (params) => {
    const blob = await fetch(`${BACKEND}/api/factures/export${qs(params)}`, { headers: authHeaders(false) }).then(handleBlob);
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `export-comptable.${params.format === 'xlsx' ? 'xlsx' : 'csv'}`;
    document.body.appendChild(a); a.click(); a.remove();
  },
  exportEmail: (body) => api.post('/api/factures/export/email', body || {}),
};

// ─── Partenaires & commissions (Lot 6) — admin ───────────────────────────────
export const apporteurs = {
  list: (statut) => api.get(`/api/apporteurs${statut ? `?statut=${statut}` : ''}`),
  valider: (id) => api.post(`/api/apporteurs/${id}/valider`, {}),
  refuser: (id, motif) => api.post(`/api/apporteurs/${id}/refuser`, { motif }),
  commissions: () => api.get('/api/apporteurs/commissions'),
  verser: (id, reference) => api.post(`/api/apporteurs/${id}/verser`, { reference }),
};

export function eur(v) {
  return `${Number(v || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}\u00A0€`;
}
export function eur0(v) {
  return `${Math.round(Number(v || 0)).toLocaleString('fr-FR')}\u00A0€`;
}
export function dfr(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d)) return String(iso).slice(0, 10);
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}
